/**
 * Overlays BFF field-config labels, hints, placeholders, and select option labels with vue-i18n keys under
 * `profile.fields.<key>` when present. Falls back to schema strings when a key is missing.
 * Resolves `placeholderI18nKey` from the schema into `placeholder` for Opal inputs.
 *
 * @param te When provided, select-option keys are only translated if `te(optPath)` is true (avoids intlify
 *   warnings for dynamic values such as IANA time zones that have no static message key).
 */
export function translateProfileFields(fields, t, te) {
    return fields.map((field) => {
        const { placeholderI18nKey, ...restField } = field;
        const key = String(field.key);
        const labelPath = `profile.fields.${key}.label`;
        const hintPath = `profile.fields.${key}.hint`;
        let label = field.label;
        if (!te || te(labelPath)) {
            const translatedLabel = t(labelPath);
            if (translatedLabel !== labelPath)
                label = translatedLabel;
        }
        let hint = field.hint;
        if (hint !== undefined && hint !== "") {
            if (!te || te(hintPath)) {
                const translatedHint = t(hintPath);
                if (translatedHint !== hintPath)
                    hint = translatedHint;
            }
        }
        let placeholder = restField.placeholder;
        if (placeholderI18nKey) {
            if (!te || te(placeholderI18nKey)) {
                try {
                    const translatedPh = t(placeholderI18nKey);
                    placeholder =
                        translatedPh !== placeholderI18nKey ? translatedPh : (restField.placeholder ?? "");
                }
                catch {
                    placeholder = restField.placeholder ?? "";
                }
            }
            else {
                placeholder = restField.placeholder ?? "";
            }
        }
        let options = field.options;
        if (options?.length) {
            options = options.map((opt) => {
                const optPath = `profile.fields.${key}.options.${String(opt.value)}`;
                if (te && !te(optPath))
                    return { ...opt };
                const translatedOpt = t(optPath);
                if (translatedOpt !== optPath)
                    return { ...opt, label: translatedOpt };
                return { ...opt };
            });
        }
        return { ...restField, label, hint, options, placeholder };
    });
}
